import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Sadece giriş yapmış kullanıcıya gösterilen rotaları sarın.
 */
export function ProtectedRoute({ children }) {
    const { isAuthenticated, ready } = useAuth();
    const location = useLocation();

    if (!ready) {
        return (
            <div className="text-center text-secondary py-5" role="status">
                Yükleniyor…
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <Navigate to="/login" state={{ from: location }} replace />
        );
    }

    return children;
}
